// extracted by mini-css-extract-plugin
export default {"Products_subContainer":"ProductsGallery_Products_subContainer__jim-Z"};